module.exports = __webpack_public_path__ + "static/icon-9f6d9204e7612835044325be3db16828.png";